import React from "react";

const ConfirmLoanDeclineModal = ({
  isConfirmLoanDeclineModalOpen,
  closeConfirmLoanDeclineModal,
  handleSubmit,
  loanCode,
  declineText,
  declineFile,
}) => {
  if (!isConfirmLoanDeclineModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50 p-4">
      <div className="relative bg-white shadow max-w-[60%] h-[38vh] mx-auto p-4 rounded-sm flex flex-col">
        {/* Close Button */}
        <button
          onClick={closeConfirmLoanDeclineModal}
          className="text-black text-lg font-bold absolute top-3 right-3"
        >
          ✖
        </button>

        <h2 className="text-xl font-bold mb-3">Decline Loan</h2>
        <div className="bg-[#F2F9F2] border-l-4 border-[#005C53] p-3 mt-4">
          <p className="text-red-600 text-base font-bold flex items-center">
            <img
              src="/red-warning.png"
              alt="red-warning"
              className="mr-2 w-5 h-5"
            />
            Warning
          </p>
          <p className="text-[#005C53] text-sm mt-2">
            By clicking 'Yes, Decline Loan,' you are confirming your intent to
            decline this loan.
          </p>
          <p className="text-[#005C53] text-sm">
            Declining this loan will reject the applicant's request. Ensure all
            details have been thoroughly reviewed before proceeding. This action
            cannot be undone.
          </p>
          <p className="text-[#005C53] text-sm mt-2">
            Are you sure you want to{" "}
            <span className="font-semibold">confirm</span> the loan decline?
          </p>
        </div>
        <div className="flex-grow"></div>
        {/* Action Buttons Positioned Higher */}
        <div className="mt-3 flex justify-between">
          <button
            onClick={closeConfirmLoanDeclineModal}
            className="px-5 py-2.5 border border-gray-500 text-gray-500 font-semibold rounded-lg w-1/2 mr-2"
          >
            No, Cancel
          </button>
          <button
            onClick={() => handleSubmit(loanCode, declineText, declineFile)}
            className="px-5 py-2.5 border border-red-500 bg-red-500 text-white font-semibold rounded-lg w-1/2"
          >
            Yes, Decline Loan
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLoanDeclineModal;
